export const ServicesFields = {
  heading: {
    type: "custom",
    label: "Heading",
    metadata: {
      source: "ai",
      description: "Section heading for services offered (e.g. 'Our Expert Services')",
      seo: true,
      key: "services.heading",
    },
  },
  subheading: {
    type: "custom",
    label: "Subheading",
    metadata: {
      source: "ai",
      description: "Brief introduction to services (15-20 words)",
      seo: true,
      key: "services.subheading",
    },
  },
  layout: {
    type: "radio",
    label: "Layout",
    options: [
      { label: "Grid", value: "grid" },
      { label: "List", value: "list" },
    ],
    metadata: {
      source: "manual",
    },
  },
  columns: {
    type: "radio",
    label: "Columns (Grid Only)",
    options: [
      { label: "2 Columns", value: "2" },
      { label: "3 Columns", value: "3" },
      { label: "4 Columns", value: "4" },
    ],
    metadata: {
      source: "manual",
    },
  },
  variant: {
    type: "radio",
    label: "Variant",
    options: [
      { label: "Minimal", value: "minimal" },
      { label: "Cards", value: "cards" },
      { label: "Feature", value: "feature" },
    ],
    metadata: {
      source: "manual",
      description: "Controls card treatment and visual emphasis.",
    },
  },
  showIcons: {
    type: "radio",
    label: "Show Icons",
    options: [
      { label: "Yes", value: "yes" },
      { label: "No", value: "no" },
    ],
    metadata: {
      source: "manual",
    },
  },
  services: {
    type: "array",
    label: "Services",
    metadata: {
      source: "context", // Services come from business data in database
      contextKey: "business.services",
      description: "List of services offered by the business",
      seo: true,
      key: "services.list",
    },
    getItemSummary: (item: { title: string }) => item.title || "New Service",
    arrayFields: {
      title: {
        type: "text",
        label: "Service Title",
        metadata: {
          description: "Service name/title",
        },
      },
      description: {
        type: "textarea",
        label: "Description",
        metadata: {
          description:
            "SEO-optimized service description (20-30 words) highlighting benefits and location",
        },
      },
      href: {
        type: "text",
        label: "Link URL (optional)",
        metadata: {
          description: "URL to service detail page (e.g. /services/courier-service)",
        },
      },
      icon: {
        type: "custom",
        label: "Icon (optional)",
        metadata: {
          format: "lucide-icon",
          description: "Lucide React icon name (e.g. 'Truck', 'Package', 'Wrench', 'Home')",
        },
      },
    },
    defaultItemProps: {
      title: "New Service",
      description: "Service description",
      href: "",
      icon: "",
    },
  },
  backgroundColor: {
    type: "text",
    label: "Background Color (optional)",
    metadata: {
      source: "manual",
    },
  },
} as const;
